// extracted by mini-css-extract-plugin
module.exports = {"maxCharacterCount":"ContactSupport_maxCharacterCount__gERXl"};